import devOnlyCss from 'lib/styles/devOnlyCss'

export default devOnlyCss`
  button button, button button:focus {
    position: relative;
    outline: 2px solid red !important;
  }

  button button:after {
    position: absolute;
    cursor: help;
    width: 200px;
    left: calc(100% + 4px);
    top: -2px;
    background-color: red;
    color: white;
    font-size: 12px;
    padding: 2px;
    border-radius: 2px;
    white-space: normal;
    content: "⚠ Warning: <button> inside another <button>. This can cause React hydration errors. Click here to learn more. ⚠"
  }
`
